export default [
    "#438708",
    "#ff939b",
    "#0a3566",
    "#00397f",
    "#ff8c7c",
    "#b4e85c",
    "#f9009a",
    "#0fc17a",
    "#ef819b",
    "#e25892",
    "#d3b5f2",
    "#b8ef8b",
    "#068400",
    "#7edd11",
    "#f98bcc",
    "#96c6dd",
    "#6d19b7",
    "#f2f76a",
    "#7ef762",
    "#c9ed90",
    "#e87dd9",
    "#f4a166",
    "#25c499",
    "#e49eef",
    "#dd7d6e",
    "#d86154",
    "#1c5d9e",
    "#f7dd4a",
    "#c6dd52",
    "#ceab10",
    "#f4cc5d",
    "#ce0ebb",
    "#b1ef77",
    "#28549b",
    "#f74c0e",
    "#b9e88b",
    "#d64644",
    "#7cbdf9",
    "#61d3d1",
    "#abe2fc",
    "#ef0229",
    "#bda3f7",
    "#fccc2f",
    "#67db9b",
    "#562ea0",
    "#4ac63f",
    "#32d30a",
    "#d36ef4",
    "#9fa7f4",
    "#c2e055",
    "#f9f616",
    "#80ea60",
    "#87b0e5",
    "#ff9e59",
    "#3588c4",
    "#b9f9a7",
    "#e21d2d",
    "#70bce5",
    "#e5c38b",
    "#b7772a",
    "#e7fc46",
    "#1f85d3",
    "#ff32d9",
    "#e89458",
    "#c4a142",
    "#1f4689",
    "#139932",
    "#0093b5",
    "#c66bea",
    "#04d6b6",
    "#db4859",
    "#27b4c4",
    "#dd39b7",
    "#d63ec4",
    "#c699ff",
    "#8bf97c",
    "#2ad332",
    "#f9c59a",
    "#c0ed38",
    "#edbb34",
    "#e894b4",
    "#c2ddfc",
    "#f9cdc2",
    "#75e575",
    "#eda59a",
    "#f4cbab",
    "#92ff63",
    "#7575ea",
    "#dd6172",
    "#50ed8a",
    "#80ff75",
    "#ea5b56",
    "#c914c0",
    "#6bb4ef",
    "#ef5c2b",
    "#5ce0e0",
    "#84032c"
];